import React from 'react';

import { SSPReportFormView } from '~/src/dash/views/ssp-report-form-view';

export function SSPReportNewView() {
  const time = 'report-' + new Date().getTime();
  return (
    <div>
      <SSPReportFormView
        report={{
          ID: '',
          CreatedAt: '',
          UpdatedAt: '',
          DeletedAt: '',

          Name: time,
          Active: 'false',
          ReportType: '4',
          SuperOnly: 1,
          Timezone: 'UTC',
          Subject: time,
          Recipients: [],
          Frequency: '1',
          ScheduledDay: '1',
          Period: '1',
          Countries: [],
          SiteIDs: [],
          BidderIDs: [],
          CampaignIDs: [],
          SegmentIDs: [],
          AdsourceIDs: [],
          Positions: [],
          DeviceTypes: [],
          BidderCodes: [],
          DemandTypes: [],
          Metrics: [],
          GroupByOptions: [],
          DMAs: '',
          States: [],
        }}
      />
    </div>
  );
}
